export default "__VITE_ASSET__BRbp3FSp__"